import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Flex } from '@stepstone-genesis/components';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/index.js';
import { navigationActions } from '../../core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { twoStepActiveStateSelector } from './twoStepLoginRegistrationSlice.js';
import { twoStepViews } from './views/twoStepViews.js';
import { activeModalTypeSelector } from '../../wrappers/Modal/modalSlice.js';
import { FadeTransition } from '../../components/FullscreenTwoStepContent/components/FadeTransition.js';
export const TwoStepLoginRegistration = () => {
    const dispatch = useAppDispatch();
    const activeView = useAppSelector(twoStepActiveStateSelector);
    const activeModalType = useAppSelector(activeModalTypeSelector);
    useEffect(() => {
        dispatch(navigationActions.setActiveForm(FORM_TYPES.BASIC_TWO_STEP));
    }, []);
    return (_jsx(Flex, { sx: {
            maxWidth: `${activeModalType === 'fullscreenTwoStep' ? '456px' : '100%'}`,
        }, children: _jsx(FadeTransition, { transitionKey: activeView, children: twoStepViews[activeView] }) }));
};
//# sourceMappingURL=TwoStepLoginRegistration.js.map